import React from 'react';
import "../Figure.css"


function Figure7() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
            <th> </th>
              <th> Zn concentration after incubation (15min)</th>
              <th> Zn concentration after removal of the blank </th>
              <th> Zn uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Blank EC20 </th>
              <td> 0.4 mg/L </td>
              <td> 0 mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
              <th> Blank SpaC </th>
              <td> 0.28 mg/L </td>
              <td> 0 mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
              <th> Water </th>
              <td> 1.41 mg/L </td>
              <td> - mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
            <th> EC20 </th>
              <td> 0.55 mg/L </td>
              <td> 0.15 mg/L </td>
              <td> 1.26 mg/L </td>
            </tr>
            <tr> 
            <th> SpaC </th>
              <td> 0.74 mg/L </td>
              <td> 0.46 mg/L </td>
              <td> 0.95 mg/L </td>
            </tr> 
            <tr>
              <th colSpan="3" className="colored-cell"> Uptake difference </th>
              <th className="colored-cell"> 0.31 mg/L </th>
            </tr> 
          </tbody>
        </table>
    </div>
  );
}

export default Figure7;